// extracted by mini-css-extract-plugin
module.exports = {"lds-rolling":"LoadingIcon_lds-rolling__2TFmr"};